import { MutableState } from 'final-form';

export const setFieldData = <
  FormValues extends object,
  InitialFormValues extends Partial<FormValues> = Partial<FormValues>,
>(
  [fieldName, fieldValue]: [string, object],
  state: MutableState<FormValues, InitialFormValues>,
) => {
  const field = state.fields[fieldName];

  if (field) {
    field.data = { ...field.data, ...fieldValue };
  }
};
